<form [formGroup]="form()">
    <div class="grid grid-cols-1 gap-4 mb-4">
        <spike-field-text 
            formControlName="shortDescription" 
            label="Titolo Movimento" 
            placeholder="Es: Spesa Supermercato">
        </spike-field-text>

        <spike-field-number 
            formControlName="amount" 
            label="Importo"
             mode="currency" 
             currency="EUR" 
            placeholder="0.00">
        </spike-field-number>

        <spike-field-date 
            formControlName="accountingDate" 
            label="Data Contabile" 
            placeholder="Seleziona data">
        </spike-field-date>

        <spike-field-select label="Wallet" [initialValue]="walletStoreService.findReactive(form().controls['finWalletId'].value)()" formControlName="finWalletId" selectKey="finWalletId" selectValue="shortDescription" listTitle="Seleziona Wallet" detailTitle="Dettaglio wallet">
            <ng-template #list>
                <spike-wallet-list #listRef [list]="walletStoreService.getList()()"/>
            </ng-template>
        </spike-field-select>

        <spike-field-select label="Etichetta" [initialValue]="etiquetteStoreService.findReactive(form().controls['etiquetteId'].value)()" formControlName="etiquetteId" selectKey="etiquetteId" selectValue="shortDescription" listTitle="Seleziona Etichetta" detailTitle="Dettaglio etichetta">
            <ng-template #list>
                <spike-etiquette-list #listRef [list]="etiquetteStoreService.getList()()"/>
            </ng-template>
        </spike-field-select>

         <spike-field-text-area 
            formControlName="description" 
            label="Note" 
            placeholder="Dettagli aggiuntivi sul movimento...">
        </spike-field-text-area>
    </div>

       
</form>